import { Box, CircularProgress, Typography } from '@mui/material';

interface CustomCircularProgressProps {
  value: number;
  label?: string;
  size?: number;
  fontsize?: number;
}

export const CustomCircularProgress: React.FC<CustomCircularProgressProps> = ({
  value,
  label = `${value}`,
  size = 45,
  fontsize = 14,
}) => {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant="determinate"
        size={size}
        value={100}
        sx={{
          color: '#471E89',
        }}
        thickness={3}
      />

      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        sx={{
          color: '#7B35EF',
          position: 'absolute',
        }}
        thickness={3}
      />

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: '#ffffff',
            fontSize: `${fontsize}px`,
            fontWeight: 700,
            lineHeight: '13px',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};
